import React                  from 'react';
import PropTypes              from 'prop-types';
import { makeStyles }         from '@material-ui/core';
import MuiModal               from '../../../components/common/MuiModal';
import Create                 from '../../../../api-platform-admin/src/Create_MVT';
import Edit                   from '../../../../api-platform-admin/src/Edit_MVT';
import GlobalLoadingIndicator from '../components/GlobalLoadingIndicator';

let useStyles = makeStyles(function (theme) {
	return ({
		drawerContent: {
			width: '100%',
			[theme.breakpoints.up('xs')]: {
				width: '100%',
			},
			[theme.breakpoints.up('sm')]: {
				width: '100%',
			},
		}
	});
});

function MuiModalCreator(props) {

	let styles = useStyles();
	const {
		disableBackdropClick,
		title,
		closeButton,
		isOpen,
		handleEditorClose,
		resource,
		basePath,
		redirect,
		options,
		contentWidth,
		contentMinWidth,
		contentMaxWidth,
		maxWidth,
		dialogContentStyle,
		location,
		formProps,
		initialValues,
		renderFields,
	} = props;

	// if(typeof console === 'object') { console.log('MuiModalCreator',isOpen); }

	const dialogCStyle = Object.assign({
		padding: 0,
		borderBottom: 0,
	},dialogContentStyle);

	return (
		<MuiModal
			draggable={true}
			disableBackdropClick={disableBackdropClick}
			closeButton={closeButton}
			contentWidth={contentWidth}
			contentMinWidth={contentMinWidth}
			contentMaxWidth={contentMaxWidth}
			maxWidth={maxWidth}
			open={isOpen}
			onClose={handleEditorClose}
			title={<React.Fragment>
				{title}
				<GlobalLoadingIndicator />
			</React.Fragment>}
			dialogContentStyle={dialogCStyle}
		>
			{isOpen ? (
				<React.Fragment>
					<Create
						renderFields={renderFields}
						className={styles.drawerContent}
						location={location}
						resource={resource}
						basePath={basePath}
						options={options}
						onCancel={handleEditorClose}
						formProps={Object.assign({
							redirect: redirect,
							initialValues: initialValues
						},formProps)}
					/>
				</React.Fragment>
			) : (
				 <div className={styles.drawerContent} />
			 )}
		</MuiModal>
	);
};

MuiModalCreator.defaultProps = {
	dialogContentStyle: {},
	formProps: {},
	disableBackdropClick: false,
	renderFields: 'editfields'
};

MuiModalCreator.propTypes = {
	title: PropTypes.string,
	closeButton: PropTypes.bool,
	disableBackdropClick: PropTypes.bool,
	isOpen: PropTypes.bool,
	resource: PropTypes.string,
	basePath: PropTypes.string,
	renderFields: PropTypes.string,
	id: PropTypes.any,
	contentWidth: PropTypes.any,
	contentMaxWidth: PropTypes.any,
	contentMinWidth: PropTypes.any,
	maxWidth: PropTypes.any,
	redirect: PropTypes.any,
	options: PropTypes.object,
	formProps: PropTypes.object,
	handleEditorClose: PropTypes.func,
	initialValues: PropTypes.object,
	dialogContentStyle: PropTypes.object,
	location: PropTypes.object,
};

export default MuiModalCreator;
// export default withStyles(styles)(withTranslate(ComponentTemplate));
// export default withTranslate(ComponentTemplate);
// export default connect(null,null)(withTranslate(ComponentTemplate));
